const STORAGE_NAME = 'app_cookie_policy_settings';

export const managerOptions = [
  {
    id: 'necessary',
    header: 'Strictly Necessary',
    description:
      'These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, filling in forms. You can set your browser to block these cookies, but some parts of the site will not then work.',
    alwaysOn: true,
  },
  {
    id: 'performanceAnalytics',
    header: 'Performance and analytics',
    description:
      'These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.',
    value: false,
  },
];

export function storeCookiePolicySettings(settings: any) {
  localStorage.setItem(
    STORAGE_NAME,
    JSON.stringify({
      accepted: true,
      settings,
    })
  );
}

export function getCookiePolicySettings() {
  return JSON.parse(localStorage.getItem(STORAGE_NAME) || '{ "accepted": false, "settings": {} }');
}

export function areCookiePolicySettingsAccepted() {
  return getCookiePolicySettings().accepted;
}
